import React, { FC } from 'react';
import SelectForm, {
  ISelectForm
} from '../../../../../../components/SelectForm';
import styles from '../../styles/index.module.scss';

const SelectTypeUser: FC<ISelectForm> = ({ ...props }) => {
  return (
    <SelectForm
      {...props}
      getOptionLabel={(item: any) => (
        <div className={styles['select--label']}>
          <img
            className={styles['select--icon']}
            alt={item.label}
            src={item.icon}
          />
          <span>{item.label}</span>
        </div>
      )}
    />
  );
};

export default SelectTypeUser;
